import { render, staticRenderFns } from "./product_additives.vue?vue&type=template&id=56e83355&scoped=true&"
import script from "./product_additives.vue?vue&type=script&lang=js&"
export * from "./product_additives.vue?vue&type=script&lang=js&"
import style0 from "./product_additives.vue?vue&type=style&index=0&id=56e83355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e83355",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e83355')) {
      api.createRecord('56e83355', component.options)
    } else {
      api.reload('56e83355', component.options)
    }
    module.hot.accept("./product_additives.vue?vue&type=template&id=56e83355&scoped=true&", function () {
      api.rerender('56e83355', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_additives.vue"
export default component.exports